module.exports = __webpack_public_path__ + "static/media/key-instructions.f15f53a6.mp4";